import axios from "axios";
import Api, { BASE_URL } from "../../shared/api/api";

function headers() {
  const token = Api.token || localStorage.getItem("token");
  if (token) Api.setToken(token);
  return token ? { Authorization: `Dragonian ${token}` } : {};
}
function uploadError(error, kind) {
  const supplied = error.response?.data?.error?.message;
  if (typeof supplied === "string") return new Error(supplied);
  const status = error.response?.status;
  const detail = status === 413 ? `The server rejected the ${kind} because the upload is too large.`
    : [408, 502, 504, 524].includes(status) || ["ECONNABORTED", "ETIMEDOUT"].includes(error.code) ? `The ${kind} upload connection timed out.`
    : !error.response ? `The connection was interrupted while uploading the ${kind}.`
    : `The ${kind} upload failed (HTTP ${status}).`;
  return new Error(`${detail} Your metadata draft is saved. Refresh drafts to check whether the file finished saving before retrying.`);
}
export function mediaRequest(endpoint, data, method) {
  headers();
  return Api.request(`api/media/${endpoint}`, data, method);
}
export async function uploadDraftFile(scope, id, file, onProgress) {
  const body = new FormData(); body.append("video", file);
  try {
    const result = await axios.post(`${BASE_URL}/api/media/${scope}/drafts/${id}/file`, body, { headers: headers(), onUploadProgress: event => onProgress(event.total ? Math.round(event.loaded * 100 / event.total) : null) });
    return result.data;
  } catch (error) { throw uploadError(error, "video file"); }
}
export async function downloadDraftFile(scope, draft) {
  const response = await axios.get(`${BASE_URL}/api/media/${scope}/drafts/${draft.id}/file`, { headers: headers(), responseType: "blob" });
  const url = URL.createObjectURL(response.data);
  const link = document.createElement("a");
  link.href = url; link.download = draft.file_name || "video.mp4";
  document.body.appendChild(link); link.click(); link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
export async function uploadDraftThumbnail(scope, id, file) {
  const body = new FormData(); body.append("thumbnail", file);
  try { return (await axios.post(`${BASE_URL}/api/media/${scope}/drafts/${id}/thumbnail`, body, { headers: headers() })).data; }
  catch (error) { throw uploadError(error, "thumbnail"); }
}
export async function draftThumbnailBlob(scope, id) {
  return (await axios.get(`${BASE_URL}/api/media/${scope}/drafts/${id}/thumbnail`, { headers: headers(), responseType: "blob" })).data;
}
